import { Modal } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import {
    createFieldDate,
    createFieldInput,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../utils/form";
import { callRequestDoc, callRequestStatus } from "../../storage-location/request/request.section";
import { callUser, checkUserCompanyOperation } from "../../storage-location/request/requestor/requestor.section";
import { calNetWeightRemaining } from "./inform-product/inform-product-qty.logic";
import { calQuantityRemaining } from "./inform-product/inform-product.logic";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const callRequestType = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_TYPE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2", "4"].includes(item.key)));
export const callUserObjective = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callUserObjective3 = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["3"].includes(item.key)));
export const callDepartmentMain = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/department/cacheFindAll", {
        where: [
            { name: "refDepartmentType.key", operator: "=", value: "main" },
            { openBucket: true, name: "nameTh", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "fullCode", operator: "like", value: searchQuery },
        ],
    });
export const callInformAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "INFORM_ATTACHMENT", value: searchQuery });
export const callImportSampleAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "IMPORT_SAMPLE_ATTACHMENT", value: searchQuery });
export const callPassAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PASS_ATTACHMENT", value: searchQuery });
export const callInformProductQtyMargin = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "INFORM_PRODUCT_QTY_MARGIN", value: searchQuery });
export const callInspectionLv = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "INSPECTION_LV", value: searchQuery });
export const callInform = ({
    searchQuery,
    userInfo,
    isOfficerCreate,
    requestDocKeys,
    isRefInspectionNull,
    isRefFreeSaleNull,
    isRefHcNull,
    isRefTransferDeclarationNull,
    notIn = []
}) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refLastRequest.refRequestType.key", type: "String", isNot: true, operator: "=", value: "4" },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { openBucket: true, name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { closeBucket: true, logic: "OR", name: "refLastRequest.refDocGenType.key", type: "String", operator: "=", value: "2" },
    ];
    if (isRefInspectionNull) {
        where.push({ name: "refInspection.id", type: "UUID", operator: "=", value: null });
    }
    if (isRefFreeSaleNull) {
        where.push({ name: "refFreeSale.id", type: "UUID", operator: "=", value: null });
    }
    if (isRefHcNull) {
        where.push({ name: "refHc.id", type: "UUID", operator: "=", value: null });
    }
    if (isRefTransferDeclarationNull) {
        where.push({ name: "refTransferDeclaration.id", type: "UUID", operator: "=", value: null });
    }
    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "refUserCompany.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "refUserCompany.id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (requestDocKeys?.length > 0) {
        where.push({ name: "refRequestDoc.key", type: "String", operator: "in", value: requestDocKeys });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    if (notIn?.length > 0) {
        where.push({ name: "id", type: "UUID", operator: "!in", value: notIn });
    }
    return store
        .dispatch("resource/v1/transaction/inform/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refOperation.*", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callInformFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/inform/search", {
            criteria: {
                select: [
                    "**",
                    "refUserCompany.refPersonType.*",
                    "refUser.refPersonType.*",
                    "refTransferDeclaration.id",
                    "refTransferDeclaration.declarationNumber",
                    "refTransferDeclaration.referenceNumber",
                    "refTransferDeclaration.containerNo",
                    "refTransferDeclaration.vehicleNo"
                ],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refTransferDeclaration.products",
                        select: ["id", "invoiceCode"],
                        page: 0,
                        size: 10000,
                        children: [
                            {
                                name: "productQties",
                                select: ["**"],
                                page: 0,
                                size: 10000
                            }
                        ]
                    },
                    {
                        name: "refUserCompany.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "products",
                        select: [
                            "**",
                            "refHazObject.refSpecies.*",
                            "refCoordinateCustoms.refUnit.*",
                            "refCoordinateCustoms.refDetailSubStanceType.*",
                            "refHaz.refManufactureCountry.*",
                            "refHazLicense.refQuantityUnit.*"
                        ],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "addresses",
                                select: ["**"],
                                page: 0,
                                size: 1,
                                where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                            },
                            {
                                name: "productQties",
                                select: ["**"],
                                page: 0,
                                size: 1000000,
                                children: [
                                    {
                                        name: "refStorageLocation.subs",
                                        select: ["*"],
                                        page: 0,
                                        size: 1000000,
                                        sort: [{ name: "createDate", type: "ASC" }],
                                        children: [
                                            {
                                                name: "items",
                                                select: ["*"],
                                                page: 0,
                                                size: 1000000,
                                                where: [
                                                    {
                                                        name: "refHaz.id",
                                                        type: "ScriptJs",
                                                        operator: "=",
                                                        value: `
                                                            var found = false;
                                                            var products = dataRoot.products;
                                                            var product = null;
                                                            for(var i = 0; !found && products != null && i < products.size(); ++i) {
                                                                var p = products[i];
                                                                var pqs = p.productQties;
                                                                for(var j = 0; !found && pqs != null && j < pqs.size(); ++j) {
                                                                    var sl = pqs[j].refStorageLocation;
                                                                    if(sl != null) {
                                                                        var ss = sl.subs;
                                                                        for(var k = 0; !found && ss != null && k < ss.size(); ++k) {
                                                                            var s = ss[k];
                                                                            if(s.id.equals(dataParent.id)) {
                                                                                found = true;
                                                                                product = p;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            found ? product.refHaz.id : null;
                                                        `
                                                    },
                                                    {
                                                        name: "refHazLicense.refOperation.key",
                                                        type: "String",
                                                        operator: "=",
                                                        value: "2"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "refStorageLocationSub.items",
                                        select: ["*"],
                                        page: 0,
                                        size: 1000000,
                                        where: [
                                            {
                                                name: "refHaz.id",
                                                type: "ScriptJs",
                                                operator: "=",
                                                value: `
                                                        var found = false;
                                                        var products = dataRoot.products;
                                                        var product = null;
                                                        for(var i = 0; !found && products != null && i < products.size(); ++i) {
                                                            var p = products[i];
                                                            var pqs = p.productQties;
                                                            for(var j = 0; !found && pqs != null && j < pqs.size(); ++j) {
                                                                var ipq = pqs[j];
                                                                if(ipq != null && ipq.id.equals(dataParent.id)) {
                                                                    found = true;
                                                                    product = p;
                                                                }
                                                            }
                                                        }
                                                        found ? product.refHaz.id : null;
                                                    `
                                            },
                                            {
                                                name: "refHazLicense.refOperation.key",
                                                type: "String",
                                                operator: "=",
                                                value: "2"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                name: "refHazObject.hazObjectCoordinates",
                                select: [
                                    "*",
                                    "refCoordinateCustoms.*",
                                    "refCoordinateCustoms.refUnit.*",
                                    "refCoordinateCustoms.refDetailSubStanceType.*"
                                ],
                                page: 0,
                                size: 1000000
                            },
                            {
                                name: "refHaz.mainSubStances",
                                select: ["*", "refSubStance.*", "refUnit.*"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }]
                            },
                            {
                                name: "refHazLicense.hazLicenseStorageLocations",
                                select: ["*", "refStorageLocation.*"],
                                page: 0,
                                size: 1000000,
                                where: [
                                    { name: "refStorageLocation.isActive", type: "Boolean", operator: "=", value: true },
                                    { name: "refStorageLocation.isTemp", type: "Boolean", operator: "=", value: false },
                                    { name: "refStorageLocation.refStatus.key", type: "String", operator: "=", value: "complete" },
                                    { name: "refStorageLocation.effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
                                    { name: "refStorageLocation.expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
                                    { name: "refStorageLocation.isLocation", type: "Boolean", operator: "=", value: true }
                                ],
                                sort: [{ name: "createDate", type: "ASC" }],
                                children: [
                                    {
                                        name: "refStorageLocation.subs",
                                        select: ["*"],
                                        page: 0,
                                        size: 1000000,
                                        sort: [{ name: "createDate", type: "ASC" }],
                                        children: [
                                            {
                                                name: "items",
                                                select: ["*"],
                                                page: 0,
                                                size: 1000000,
                                                where: [
                                                    {
                                                        name: "refHaz.id",
                                                        type: "ScriptJs",
                                                        operator: "=",
                                                        value: `
                                                            var found = false;
                                                            var products = dataRoot.products;
                                                            var product = null;
                                                            for(var i = 0; !found && products != null && i < products.size(); ++i) {
                                                                var p = products[i];
                                                                var hl = p.refHazLicense;
                                                                if(hl != null) {
                                                                    var hlsls = hl.hazLicenseStorageLocations;
                                                                    for(var j = 0; !found && hlsls != null && j < hlsls.size(); ++j) {
                                                                        var sl = hlsls[j].refStorageLocation;
                                                                        if(sl != null) {
                                                                            var ss = sl.subs;
                                                                            for(var k = 0; !found && ss != null && k < ss.size(); ++k) {
                                                                                var s = ss[k];
                                                                                if(s.id.equals(dataParent.id)) {
                                                                                    found = true;
                                                                                    product = p;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            found ? product.refHaz.id : null;
                                                        `
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: "attachments",
                        select: ["*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};

export const createColumns = ({ props }) => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.inform.refUserCompany"),
            dataIndex: "refInformTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refInformTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refInformTemp?.refUserCompany?.companyNameTh
                    : record.refInformTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.inform.approveCode"), dataIndex: "refInform.approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.inform.expireDate"), dataIndex: "refInform.expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.inform.invoiceCode"),
            dataIndex: "refInformTemp.products.invoiceCode",
            dataIndexValue: ({ record }) => record.refInformTemp?.products.map(d => d.invoiceCode).join("\r\n"),
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "center"
        }),
        createColumnInput({
            visible: () => ["16", "17", "02"].some(d => props.requestDocKeys.includes(d)),
            title: () => i18n.global.t("model.inform.eformCode"),
            dataIndex: "refInformTemp.eformCode",
            align: "center"
        }),
        createColumnSelect({
            visible: () => ["16", "17", "18", "19"].some(d => props.requestDocKeys.includes(d)),
            title: () => i18n.global.t("model.inform.refOperation"),
            dataIndex: "refInformTemp.refOperation.value",
            inputProp: () => ({
                list: ({ searchQuery }) =>
                    ["16", "17"].some(d => props.requestDocKeys.includes(d))
                        ? callUserObjective({ searchQuery })
                        : callUserObjective3({ searchQuery }),
                optLabel: "value"
            }),
            search: { visible: () => ["16", "17"].some(d => props.requestDocKeys.includes(d)), name: "refInformTemp.refOperation.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => (
                <div>
                    <span>{record.refRequestType?.value}</span>
                    {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
                </div>
            ),
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartmentMain, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.inform.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, refs, key }) => {
    const { viewOnly, requestDocKeys } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    data.onUpdateRefOperation = createOnUpdateRefOperation({ props, data, refs, key });
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refInform
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("model.request.refRequestType") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1"].includes(value?.key)) {
                                                const { createForm } = require("./request.logic");
                                                cloneInform({
                                                    props,
                                                    model: {
                                                        ...createForm({ props, data, refs }),
                                                        id: model.id,
                                                        version: model.version,
                                                        isActive: model.isActive,
                                                        refStatus: model.refStatus,
                                                        refRequestDoc: model.refRequestDoc,
                                                        draftCode: model.draftCode,
                                                        requestCode: model.requestCode
                                                    }
                                                });
                                            } else {
                                                cloneInform({ props, model, id: model.refInform?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: callRequestType,
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInform`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.storageLocation.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refInform,
                            "onUpdate:value": value => {
                                const oldValue = model.refInform;
                                model.refInform = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.inform.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneInform({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refInform = oldValue;
                                        }
                                    });
                                } else {
                                    cloneInform({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callInform({
                                    searchQuery,
                                    userInfo: store.state.resource.auth.info?.user,
                                    isOfficerCreate: model.isOfficerCreate,
                                    requestDocKeys,
                                    isRefInspectionNull: true,
                                    isRefFreeSaleNull: true,
                                    isRefHcNull: true,
                                    isRefTransferDeclarationNull: true
                                }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInformTemp.refOperation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refOperation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformTemp?.refOperation,
                            "onUpdate:value": data.onUpdateRefOperation,
                            disabled: viewOnly || !model.refInformTemp.refUserCompany,
                            list: ({ searchQuery }) =>
                                callUserObjective({ searchQuery }).then(items =>
                                    checkUserCompanyOperation({ operations: items, userCompany: model.refInformTemp.refUserCompany })
                                ).then(items => {
                                    if (["02"].includes(modelRef.refRequestDoc?.key)) {
                                        return items.filter(d => d.key === "1")
                                    }
                                    return items;
                                }),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestCodeTitle`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.requestCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInform.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInform?.approveCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInformTemp.eformCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.eformCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformTemp?.eformCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => ((model.refDocGenType?.key === "2" && model.refRequestType?.key === "1") || model.refHaz?.effectiveDate) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInformTemp.effectiveDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.effectiveDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformTemp?.effectiveDate,
                            "onUpdate:value": value => (model.refInformTemp.effectiveDate = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => ((model.refDocGenType?.key === "2" && model.refRequestType?.key === "1")) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInformTemp.approveManualDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.approveManualDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformTemp?.approveManualDate,
                            "onUpdate:value": value => {
                                model.refInformTemp.approveManualDate = value
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => (model.refInform?.expireDate) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInform.expireDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.expireDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformTemp?.expireDate || model.refInform?.expireDate,
                            "onUpdate:value": value => (model.refInformTemp.expireDate = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly || model.isOfficerCreate
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forReceiveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forReceiveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forReceiveRemark[0].remark = value),
                            disabled: viewOnly || model.isOfficerCreate
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const cloneInform = ({ props, model, id }) => {
    const { requestDocKeys } = props;
    if (id) {
        callInformFull({ id }).then(inform => {
            const refInformTemp = copyForm({ form: { ...inform, isTemp: true } });
            if (id) {
                refInformTemp.attachments.forEach((d, index) => {
                    d.refRealId = inform.attachments[index].id;
                    if (["02"].some(d => requestDocKeys.includes(d))) {
                        d.url = null;
                        d.type = null;
                        d.name = null;
                        d.size = null;
                        d.path = null;
                    }
                });
                refInformTemp.products.forEach((d, index) => {
                    d.refReal = { id: inform.products[index].id };
                    d.productQties.forEach((d2, index2) => (d2.refReal = { ...inform.products[index].productQties[index2] }));
                    d.addresses.forEach((d2, index2) => (d2.refRealId = inform.products[index].addresses[index2].id));
                });

                // restore id for dropdown
                refInformTemp.products
                    .flatMap(d => d.productQties || [])
                    .flatMap(d => d.refStorageLocation?.subs || [])
                    .forEach(d => (d.id = d._id));
                refInformTemp.products
                    .flatMap(d => d.refHazLicense?.hazLicenseStorageLocations || [])
                    .flatMap(d => d.refStorageLocation?.subs || [])
                    .forEach(d => (d.id = d._id));
                refInformTemp.products
                    .flatMap(d => d.productQties || [])
                    .flatMap(d => d.refStorageLocation?.subs || [])
                    .flatMap(d => d.items || [])
                    .forEach(d => (d.id = d._id));
                refInformTemp.products
                    .flatMap(d => d.refHazLicense?.hazLicenseStorageLocations || [])
                    .flatMap(d => d.refStorageLocation?.subs || [])
                    .flatMap(d => d.items || [])
                    .forEach(d => (d.id = d._id));
                refInformTemp.products
                    .flatMap(d => d.productQties || [])
                    .flatMap(d => d.refStorageLocationSub?.items || [])
                    .forEach(d => (d.id = d._id));
            }
            return callUser({ userCompanyId: refInformTemp.refUserCompany.id }).then(users => {
                refInformTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id) || refInformTemp.refUser;
                router.push({
                    name: router.currentRoute.value.name,
                    params: {
                        props: JSON.stringify({
                            form: {
                                ...model,
                                refRequestDoc: inform.refRequestDoc,
                                refDepartment: inform.refDepartment,
                                refInformTemp
                            }
                        })
                    },
                    query: { _timestamp: new Date().getTime() }
                });
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

export const requiredQuantityRemaining = ({ initInform, informProduct }) => {
    return {
        validator: () => {
            if (informProduct.refHazLicense) {
                let balance = calQuantityRemaining({
                    hazLicense: informProduct.refHazLicense,
                    informProductQties: informProduct.productQties,
                    initInformProductQties: initInform?.products
                        .filter(d => d.id && informProduct.id && d.id === informProduct.id)
                        .flatMap(d => d.productQties)
                });
                if (balance < 0) {
                    return Promise.reject(i18n.global.t("error.v1InformProductQtyService.processNetWeightLicense.quantityRemaining.notEnough"));
                }
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const requiredNetWeight = ({ data, request, inform, initInform, informProduct, productQty, initProductQty }) => {
    return {
        validator: (rule, value) => {
            if (value === undefined || value === null || value?.length === 0 || value?.toString()?.length === 0) {
                return Promise.reject(i18n.global.t("error.form.required"));
            }
            if (productQty.refStorageLocationSub) {
                let balance = calNetWeightRemaining({
                    request,
                    inform,
                    initInform,
                    informProduct: informProduct,
                    informProductQties:
                        inform.refOperation?.key === "1"
                            ? inform.products.flatMap(d => d.productQties)
                            : inform.products.filter(d => d.refHazObject?.id === informProduct.refHazObject?.id).flatMap(d => d.productQties),
                    initInformProductQties:
                        inform.refOperation?.key === "1"
                            ? initInform.products.flatMap(d => d.productQties)
                            : initInform.products.filter(d => d.refHazObject?.id === informProduct.refHazObject?.id).flatMap(d => d.productQties),
                    storageLocationSub: productQty.refStorageLocationSub,
                    storageLocationSubItem: productQty.refStorageLocationSubItem
                });
                if (inform.refOperation?.key === "1") {
                    const marginPercent = data.informProductQtyMargins?.[0]?.value || 0;
                    const useKg = productQty.refStorageLocationSub.useKg;
                    const useKgReserve = productQty.refStorageLocationSub.useKgReserve;
                    const useKgReserveThis = initInform.products
                        .flatMap(d => d.productQties)
                        .map(d => d.netWeight?.toString())
                        .filter(d => d)
                        .reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0);
                    const useKgUse = productQty.refStorageLocationSub.useKgUse;
                    const useKgRemaining =
                        useKg +
                        (inform.refOperation?.key === initInform.refOperation?.key ? useKgReserveThis : 0.0) -
                        useKgReserve -
                        useKgUse +
                        (initProductQty?.netWeight || 0);
                    const margin = (parseFloat(productQty.refStorageLocationSub.useKg) * parseFloat(marginPercent)) / 100.0;
                    /*
                    console.log({
                        useKg,
                        useKgReserve,
                        useKgReserveThis,
                        useKgUse,
                        useKgRemaining,
                        margin
                    });
                    */
                    if (useKgRemaining <= 0 || balance < -margin) {
                        return Promise.reject(i18n.global.t("error.v1InformProductQtyService.processNetWeightStorage.useKgRemaining.notEnough"));
                    }
                } else if (inform.refOperation?.key === "2") {
                    if (balance < 0) {
                        return Promise.reject(i18n.global.t("error.v1InformProductQtyService.processNetWeightStorage.useKgRemaining.notEnough"));
                    }
                }
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const createOnUpdateRefOperation = ({ data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return value => {
        //refOperation = 1 นำเข้า, 2 ส่งออก
        if (["16", "17"].includes(model.refRequestDoc?.key)) {
            model.refInformTemp.refOperation = value;
            if (value) {
                callRequestDoc({}).then(items => {
                    model.refRequestDoc = items.find(item => {
                        if ((value.key === "1" && item.key === "16") || (value.key === "2" && item.key === "17")) {
                            return item;
                        }
                    });
                    model.refInformTemp.refRequestDoc = model.refRequestDoc;
                });
            } else {
                model.refRequestDoc = null;
                model.refInformTemp.refRequestDoc = null;
            }
            lodash.remove(model.refInformTemp.products, d => !d.id);
            model.refInformTemp.products.forEach(d => {
                d.isDelete = true;
                lodash.remove(d.productQties, d => !d.id);
                d.productQties.forEach(d => (d.isDelete = true));
            });
        }
    };
};
